import React, { Component } from 'react';
import SchedulleColumn from './SchedulleColumn';
import UserSelect from '../Users/UserSelect';
import MainStore from '../../../MainStore';
import SchedulleColumnHeader from './SchedulleColumnHeader';
import { HubConnectionBuilder } from '@aspnet/signalr';
import SchedulleCard from './SchedulleCard'
import FormControl from '@mui/material/FormControl';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import './scheduller.css';
import PeriodPicker from './PeriodPicker';
import Switch from '@mui/material/Switch';
import CalendarDay from './Calendar/CalendarDay';
import { observer } from 'mobx-react';
import AuthStore from '../../Auth/AuthStore';
import OutlookCalendar from './OutlookCalendar';

const PeopleSchedule = observer(class PeopleSchedule extends Component {

    constructor(props) {
        super(props);

        this.columns = [
            { name: 'Понедельник', day: 1 },
            { name: 'Вторник', day: 2 },
            { name: 'Среда', day: 3 },
            { name: 'Четверг', day: 4 },
            { name: 'Пятница', day: 5 },
            { name: 'НеПятница', day: 6 },
        ];

        this.state = {
            works: [],
            viewType: 0,
            user: (!!localStorage.getItem('schedulle_UserFilter') ? JSON.parse(localStorage.getItem('schedulle_UserFilter')) : null),
            searchStr: '',
            isCalendarView: false
        };

        const hubConnection = new HubConnectionBuilder()
            .withUrl("/hub")
            .build();

        var scope = this;

        hubConnection.on('schedulleUpdated', (work) => {
            if (!scope.state.user || scope.state.user.id === work.userId) {
                var works = scope.state.works;
                var index = works.findIndex(w => w.id === work.id);
                if (index < 0) {
                    works.push(work);
                }
                else {
                    works[index] = work;
                }

                works = works.sort((a, b) => new Date(b.start) > new Date(a.start) ? -1 : 1)
                scope.setState({ works: works });
            }
        });

        hubConnection.start();

        this.onUserChange = this.onUserChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleCheckedChange = this.handleCheckedChange.bind(this);
        this.load = this.load.bind(this);
        this.handlePeriodChange = this.handlePeriodChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.loadWorks = this.loadWorks.bind(this);
    }

    componentDidMount() {
        this.load();
        this.loadWorks();
    }

    load(dates, callback) {
        var scope = this;
        MainStore.setMaskVisible();
        var user = this.state.user;
        fetch('api/Schedulle?userId=' + (user ? user.id : (this.state.user ? this.state.user.id : '')) + '&start=' + (dates ? dates.start.toISOString() : (this.state.dates ? this.state.dates.start.toISOString() : '')), {
            method: 'GET',
            body: null,
        }).then(function(res) {
            if (res.status === 401) {
                MainStore.setMaskUnvisible();
            }
            else {
                res.json().then((result) => {
                    if (callback) callback(result.works);
                    scope.setState({ works: result.works });
                    MainStore.setMaskUnvisible();
                }).catch((err) => console.log(err));
            }
        });
    }

    onUserChange(user) {
        localStorage.setItem('schedulle_UserFilter', JSON.stringify(user));
        this.setState({ user: user }, this.load);
    }

    handleChange = name => evt => {
        this.setState({ [name]: evt.target.value });
    }

    handleCheckedChange = name => evt => {
        this.setState({ [name]: evt.target.checked });
    }

    handlePeriodChange(dates) {
        this.setState({ dates: dates });
        this.load(dates);
    }

    handleInputChange(e) {
        this.setState({ searchStr: e.target.value }, () => this.loadWorks());
    }

    loadWorks() {
        var scope = this;
        var token = localStorage.getItem("token");
        fetch('api/Work/GetMyRecentWork?name=' + this.state.searchStr, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            body: null,
        }).then(function(res) {
            if (res.status === 401) {
                MainStore.setMaskUnvisible();
                AuthStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    scope.setState({ tasks: result });
                }).catch((err) => console.log(err));
            }
        });
    }

    render() {
        //var tasks = this.state.works.map(w => { return { start: new Date(w.start), end: new Date(w.end) } });
        //console.log(tasks);
        return (
            <div>
                <div className="schedule-settings-panel clearfix">
                    <div className="schedule-setting-block">
                        <UserSelect label="Сотрудник" name={this.state.user && this.state.user.name} handleSelect={this.onUserChange} />
                        <PeriodPicker viewType={0} onPeriodChange={this.handlePeriodChange} />
                    </div>
                    {this.state.user && this.state.user.name &&
                        <Switch
                            checked={this.state.isCalendarView}
                            onChange={this.handleCheckedChange('isCalendarView')}
                            value="isCalendarView"
                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                        />}
                </div>
                <div className="left-schedulle-block">
                    <FormControl>
                        <InputLabel htmlFor="work-required">Работа</InputLabel>
                        <Input required
                            id="work-required"
                            type='text'
                            label="Работа"
                            fullWidth
                            margin="none"
                            value={this.state.searchStr}
                            onChange={this.handleInputChange}
                            autoComplete='off'
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="Toggle password visibility"
                                        onClick={this.handleClear}
                                        size="large">
                                        x
                                </IconButton>
                                </InputAdornment>
                            }
                        />
                    </FormControl>

                    {this.state.tasks && this.state.tasks.map(t => <SchedulleCard key={t.id} work={t} />)}
                </div>
                <div className="right-schedulle-block">
                    {!this.state.isCalendarView && this.columns.map((column) => {
                        return (
                            <SchedulleColumn
                                name={column.name}
                                id={column.day}
                                works={this.state.works.filter((w) => { return w.day === column.day; })}
                                onDragEnter={this.handleOnDragEnter}
                                onDragEnd={this.handleOnDragEnd}
                                key={column.day}
                                onDragPositionChange={this.handleDragSrcPositionChange}
                                onCardOpen={this.handleCardOpen}
                                onCtrlCardClick={this.handleCtrlCardClick}
                            />
                        );
                    })}

                    {this.state.isCalendarView && <div>
                            <OutlookCalendar />
                    </div>}
                </div>
            </div>
        );
    }
});

export default PeopleSchedule;